import React from "react";
import { Modal } from "antd";
import { CONSTANTS } from "config/constant";

import minusIcon from "../../assets/img/orders/minusIcon.png";
import plusIcon from "../../assets/img/orders/plusIcon.png";
const DetailModalCards = ({
  selectedItem,
  handleCountMinus,
  handleCountPlus,
  itemCounts,
  itemNotes,
  updateNote,
  totalPrice,
  setTotalPrice,
}) => {
  console.log("slected item", selectedItem, itemCounts);
  // const calculateTotalPrice = (price, count) => {
  //   return price * count;
  // };
  // console.log("totalPrice detail", totalPrice);

  if (!selectedItem) {
    return null; // or some fallback UI
  }

  const handleNoteChange = (e) => {
    if (selectedItem && selectedItem._id) {
      updateNote(selectedItem._id, e.target.value);
    }
  };

  console.log('')
  return (
    <>
      <div className="flex items-center justify-around pb-0 pt-0">
        <div>
          <img
            src={CONSTANTS?.IMG_DIRECTORY + selectedItem?.images?.[0]?.file_url}
            alt="Thobe Summer"
            className="h-32 w-32 rounded-[50%] object-cover"
          />
          <p className="mt-3 text-center text-sm text-gray-500">
            {selectedItem?.name}
          </p>
        </div>
        <div className="items-normal flex flex-col">
          {selectedItem?.item_service?.map((service) => {
            const itemId = service._id;
            const count = itemCounts[itemId] || 0;
            console.log("idddddd", itemId, count);
            return (
              <div className="flex items-center justify-center gap-2">
                <div className="mb-4">
                  <p className="text-sm text-gray-500">{service?.name}</p>
                  <div className="">
                    <p className="text-sm text-gray-500">
                      {service?.service_info?.name}
                    </p>
                    <h3 className="font-poppins font-semibold text-[#3860A4]">
                      SAR {service?.price}
                      {/* SAR{totalPrice} */}
                      {/* SAR {count ? service?.price * count : service?.price} */}
                    </h3>
                  </div>
                </div>
                <div
                  className=" ml-auto flex space-x-4 bg-[#172e5512]"
                  style={{
                    padding: "4px 6px",
                    borderRadius: "100px",
                    width: "5.5rem",
                  }}
                >
                  <img
                    src={minusIcon}
                    className="w-[1.2rem]"
                    onClick={() => {
                      handleCountMinus(itemId);
                    }}
                  />
                  <p className="text-600 text-[#3860A4]">
                    {/* {itemCounts[selectedItem?._id] || 1} */}
                    {count}
                  </p>
                  <img
                    src={plusIcon}
                    className="w-[1.2rem]"
                    onClick={() => {
                      handleCountPlus(itemId);
                      console.log("Clicked", itemId);
                    }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="relative mt-4">
        <label
          for="floating_outlined"
          className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
        >
          Add Note
        </label>
        <input
          className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
          type="text"
          name="note"
          placeholder="Add Note"
          value={itemNotes[selectedItem?._id] || ""}
          onChange={handleNoteChange}
        />
      </div>
    </>
  );
};

export default DetailModalCards;
// import React from "react";
// import minusIcon from "../../assets/img/orders/minusIcon.png";
// import plusIcon from "../../assets/img/orders/plusIcon.png";
// import { CONSTANTS } from "config/constant";

// const DetailModalCards = ({
//   selectedItem,
//   handleCountMinus,
//   handleCountPlus,
//   itemCounts,
//   itemNotes,
//   updateNote,
// }) => {
//   if (!selectedItem) {
//     return null; // or some fallback UI
//   }

//   const handleNoteChange = (e) => {
//     if (selectedItem && selectedItem._id) {
//       updateNote(selectedItem._id, e.target.value);
//     }
//   };

//   return (
//     <>
//       <div className="flex items-center justify-around pb-0 pt-0">
//         <div>
//           <img
//             src={CONSTANTS?.BACKEND_URL + selectedItem?.images?.[0]?.file_url}
//             alt="Item"
//             className="h-32 w-32 rounded-[50%] object-cover"
//           />
//           <p className="mt-3 text-center text-sm text-gray-500">
//             {selectedItem?.name}
//           </p>
//         </div>
//         <div>
//           {selectedItem?.item_service.map((service) => {
//             const itemId = service._id;
//             const count = itemCounts[itemId] || 1;

//             return (
//               <div key={itemId} className="flex items-center gap-2">
//                 <div className="mb-4">
//                   <p className="text-sm text-gray-500">{service?.name}</p>
//                   <div>
//                     <h3 className="font-poppins font-semibold text-[#3860A4]">
//                       SAR {service?.price * count}
//                     </h3>
//                   </div>
//                 </div>
//                 <div className="mb-4 flex space-x-4 bg-[#172e5512]">
//                   <img
//                     src={minusIcon}
//                     className="w-[1.2rem] cursor-pointer"
//                     onClick={() => handleCountMinus(itemId)}
//                   />
//                   <p className="text-600 text-[#3860A4]">{count}</p>
//                   <img
//                     src={plusIcon}
//                     className="w-[1.2rem] cursor-pointer"
//                     onClick={() => handleCountPlus(itemId)}
//                   />
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>

//       <div className="relative mt-4">
//         <label
//           htmlFor="note"
//           className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
//         >
//           Add Note
//         </label>
//         <input
//           id="note"
//           className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
//           type="text"
//           name="note"
//           placeholder="Add Note"
//           value={itemNotes[selectedItem?._id] || ""}
//           onChange={handleNoteChange}
//         />
//       </div>
//     </>
//   );
// };

// export default DetailModalCards;
